import * as r from 'ramda';
import {tabTitleIndexing} from './functions';

export function finished(state) {
    return state.finished ? state.finished : false;
}

export function selectedItems(state) {
    return state.items.filter((item) => item.selected);
}

export function canFinish(state) {
    return (
        r.equals(
            selectedItems(state).length,
            visibleTabs(state).filter((tab) => !tab.isPastry).length
        ) &&
        r.equals(
            selectedItems(state)
                .map((item) => item.selectedPastryCrocoCode)
                .filter((code) => !!code).length,
            visibleTabs(state).filter((tab) => tab.isPastry).length
        )
    );
}

export function previousTab(state, order) {
    return tabs(state)
        .filter((tab) => tab.order < order)
        .pop();
}

export function items(state) {
    let items;
    const currentTab = selectedTab(state);
    if (currentTab.isPastry) {
        const itemFromPreviousTab = selectedItem(
            state,
            previousTab(state, currentTab.order).id
        );
        if (itemFromPreviousTab) {
            items = r.map(
                r.cond([
                    [
                        (item) =>
                            item.crocoCode ===
                            itemFromPreviousTab.selectedPastryCrocoCode,
                        r.assoc('selected', true),
                    ],
                    [r.T, (item) => item],
                ]),
                state.pastries.filter((pastry) =>
                    itemFromPreviousTab.pastries.includes(pastry.crocoCode)
                )
            );
        } else {
            items = state.pastries;
        }
        items = r.map(r.assoc('tab', currentTab.id), items);
    } else {
        items = state.items.filter((item) => item.tab === currentTab.id);
    }

    return items;
}

export function tabs(state) {
    return state.tabs.sort((a, b) => a.order - b.order);
}

export function selectedTab(state) {
    return state.tabs.filter((tab) => tab.selected).shift();
}

export function firstTab(state) {
    return state.tabs[0];
}

export function visibleTabs(state) {
    const _tabs = tabs(state).filter((tab) => {
        const item = selectedItem(state, tab.id - 1);
        return !item || !tab.isPastry || item.pastries.length;
    });
    const indexTab = tabTitleIndexing(_tabs);
    return _tabs.map((tab) => {
        tab.title = (indexTab(tab) + ` ${tab.title}`).trim();
        return tab;
    });
}

export function selectedItem(state, tabId) {
    return state.items
        .filter((item) => item.tab === tabId && item.selected)
        .pop();
}

export function menuDescription(state) {
    return state.menuDescription
        ? state.menuDescription.replace(/,\s+$/, '')
        : state.staticTexts.emptyMenuDescription;
}

export function staticTexts(state) {
    return state.staticTexts;
}

export function pastries(state) {
    return state.pastries;
}
